// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetCreateForm-modulecell__sSi4Q ProfileContactsWidgetListCell-modulecell__WYdgk";
export { _1 as "cell" }
